import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2eb09c1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "毛孩交友会——快乐遛宠，共享萌趣时光", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags"
}, "欢快聚会", -1));

const _hoisted_6 = {
  class: "info"
};
const _hoisted_7 = {
  class: "info-item"
};
const _hoisted_8 = ["src"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动主办", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "成都天府绿道", -1));

const _hoisted_11 = {
  class: "info-item"
};
const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动时间", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "2025.06.03-06.04", -1));

const _hoisted_15 = {
  class: "info-item"
};
const _hoisted_16 = ["src"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "开展景区", -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "桂溪生态公园", -1));

const _hoisted_19 = {
  class: "info-item"
};
const _hoisted_20 = ["src"];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动地点", -1));

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "四川省成都市武侯区桂溪生态公园", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc"
}, "活动介绍", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "word"
}, " 在城市繁忙的生活中，毛孩子们也需要社交和快乐！“萌宠社交日”是一场专为宠物和主人打造的户外互动派对，让您的爱宠在阳光下自由奔跑、结识伙伴，同时您也能与其他宠物爱好者交流养宠心得，享受轻松愉快的周末时光。 ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "top-img",
    src: $setup.jyh
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $setup.zbf,
    class: "icon"
  }, null, 8, _hoisted_8), _hoisted_9, _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: $setup.time,
    class: "icon"
  }, null, 8, _hoisted_12), _hoisted_13, _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
    src: $setup.addr,
    class: "icon"
  }, null, 8, _hoisted_16), _hoisted_17, _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
    src: $setup.loca,
    class: "icon"
  }, null, 8, _hoisted_20), _hoisted_21, _hoisted_22])]), _hoisted_23, _hoisted_24])]);
}